// extracted by mini-css-extract-plugin
module.exports = {"input":"a10a3f92e9--input--OrNEu","invalid":"a10a3f92e9--invalid--UXaaT","desktop":"a10a3f92e9--desktop--XZ4Za","mobile":"a10a3f92e9--mobile--I31cN"};